// import primary libraries
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import _ from 'lodash';

import * as adminResourceRoutes from '../../../config/adminResourceRoutes.js';

import AdminLayout from '../layouts/AdminLayout.jsx';
import { useLoggedInUser } from '../../../resources/user/authService.js';

const SuperAdminRouter = () => {
  const loggedInUser = useLoggedInUser();
  return (
    <Suspense fallback={<AdminLayout.Skeleton />}>
      <AdminLayout
        title={'Admin'}
        className="pb-2 bg-neutral-sec min-h-full"
        loggedInUser={loggedInUser}
      >
        {Object.keys(adminResourceRoutes).map((resourceName, i) =>
          <Route
            component={adminResourceRoutes[resourceName]}
            key={`adminResourceRoute-${i}`}
            path={`/super/${_.kebabCase(resourceName)}`}
          />
        )}
      </AdminLayout>
    </Suspense>
  );
}

export default SuperAdminRouter;